import React from 'react';

import PropTypes from 'prop-types';
import './index.scss';

const WalletSectionHeader = ({
  title,
  actionText,
  onAction,
  hideAction = false,
  className = '',
  titleClassName = '',
  icon: Icon = 'span'
}) => {
  return (
    <div className={`wallet-section-header ${className}`}>
      <h3 className={`wallet-section-header__title ${titleClassName}`}>
        {title}
      </h3>

      {!hideAction && actionText && (
        <button
          type="button"
          className="wallet-section-header__action"
          onClick={onAction}
        >
          {actionText}
          <Icon />
        </button>
      )}
    </div>
  );
};

WalletSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
  hideAction: PropTypes.bool,
  className: PropTypes.string
};

export default WalletSectionHeader;
